import getItemStyle from './getItemStyle';

/**
 * Get the height of the square grid container from the count of items.
 * @param {number} columnCount
 * @param {number} columnGap
 * @param {number} itemCount
 * @param {number} itemSize
 * @param {number} rowGap
 * @returns {number}
 */
const getContainerHeight = (columnCount, columnGap, itemCount, itemSize, rowGap) => {
  if (itemCount === 0) {
    return 0;
  }
  const lastItemIndex = itemCount - 1;
  const lastItemStyle = getItemStyle(columnCount, columnGap, lastItemIndex, itemSize, rowGap);
  return lastItemStyle.top + lastItemStyle.height;
};

export default getContainerHeight;
